import styled from 'styled-components';

const LandUsePlan = ({ landUsePlan }: any) => {
  return (
    <Container>
      <Header>
        <img src="/assets/images/icon/land_analysis.svg"></img>
        토지이용계획
      </Header>
      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          fontFamily: 'Spoqa Han Sans Neo',
          fontWeight: '500',
          fontSize: '14px',
          textAlign: 'center',
          border: '1px solid #E8E9EA',
          lineHeight: '20.30px',
          borderSpacing: '0',
        }}
      >
        <tbody>
          <tr style={{ borderBottom: '1px solid #E8E9EA' }}>
            <td
              style={{
                color: '#616161',
                padding: '10px 12px',
                width: '110px',
                textAlign: 'center',
                wordWrap: 'break-word',
                fontSize: '13px',
                lineHeight: '18.85px',
                backgroundColor: '#F7F8FC',
              }}
              rowSpan={3}
            >
              국토의 계획 및<br />
              이용에 관한 법률
            </td>
            <td
              style={{
                color: '#171E26',
                padding: '10px 12px',
                textAlign: 'center',
                width: '51px',
                borderRight: '1px #E8E9EA solid',
              }}
            >
              포함
            </td>
            <td
              style={{
                color: '#171E26',
                padding: '10px 12px',
                textAlign: 'center',
              }}
            >
              {landUsePlan.landLaw1.contain.map(
                (item: string, index: number) => (
                  <div key={index} style={{ textAlign: 'center' }}>
                    {item}
                    {index !== landUsePlan.landLaw1.contain.length - 1 && ','}
                  </div>
                ),
              )}
            </td>
          </tr>
          <tr style={{ borderBottom: '1px solid #E8E9EA' }}>
            <td
              style={{
                color: '#171E26',
                padding: '10px 12px',
                textAlign: 'center',
                width: '51px',
                borderRight: '1px #E8E9EA solid',
              }}
            >
              저촉
            </td>
            <td
              style={{
                color: '#171E26',
                padding: '10px 12px',
                textAlign: 'center',
              }}
            >
              {landUsePlan.landLaw1.conflict.map(
                (item: string, index: number) => (
                  <div key={index} style={{ textAlign: 'center' }}>
                    {item}
                    {index !== landUsePlan.landLaw1.conflict.length - 1 && ','}
                  </div>
                ),
              )}
            </td>
          </tr>
          <tr style={{ borderBottom: '1px solid #E8E9EA' }}>
            <td
              style={{
                color: '#171E26',
                padding: '10px 12px',
                textAlign: 'center',
                width: '51px',
                borderRight: '1px #E8E9EA solid',
              }}
            >
              접합
            </td>
            <td
              style={{
                color: '#171E26',
                padding: '10px 12px',
                textAlign: 'center',
              }}
            >
              {landUsePlan.landLaw1.touch.map((item: string, index: number) => (
                <div key={index} style={{ textAlign: 'center' }}>
                  {item}
                  {index !== landUsePlan.landLaw1.touch.length - 1 && ','}
                </div>
              ))}
            </td>
          </tr>
          <tr style={{ borderBottom: '1px solid #E8E9EA' }}>
            <td
              style={{
                color: '#616161',
                padding: '10px 12px',
                width: '110px',
                textAlign: 'center',
                backgroundColor: '#F7F8FC',
                fontSize: '13px',
                lineHeight: '18.85px',
              }}
              rowSpan={3} // 숫자로 전달
            >
              기타법률
            </td>
            <td
              style={{
                color: '#171E26',
                padding: '10px 12px',
                textAlign: 'center',
                width: '51px',
                borderRight: '1px #E8E9EA solid',
              }}
            >
              포함
            </td>
            <td
              style={{
                color: '#171E26',
                padding: '10px 12px',
                textAlign: 'center',
              }}
            >
              {landUsePlan.landLaw2.contain.map(
                (item: string, index: number) => (
                  <div key={index} style={{ textAlign: 'center' }}>
                    {item}
                    {index !== landUsePlan.landLaw2.contain.length - 1 && ','}
                  </div>
                ),
              )}
            </td>
          </tr>
          <tr style={{ borderBottom: '1px solid #E8E9EA' }}>
            <td
              style={{
                color: '#171E26',
                padding: '10px 12px',
                textAlign: 'center',
                width: '51px',
                borderRight: '1px #E8E9EA solid',
              }}
            >
              저촉
            </td>
            <td
              style={{
                color: '#171E26',
                padding: '10px 12px',
                textAlign: 'center',
              }}
            >
              {landUsePlan.landLaw2.conflict.map(
                (item: string, index: number) => (
                  <div key={index} style={{ textAlign: 'center' }}>
                    {item}
                    {index !== landUsePlan.landLaw2.conflict.length - 1 && ','}
                  </div>
                ),
              )}
            </td>
          </tr>
          <tr style={{ borderBottom: '1px solid #E8E9EA' }}>
            <td
              style={{
                color: '#171E26',
                padding: '10px 12px',
                textAlign: 'center',
                width: '51px',
                borderRight: '1px #E8E9EA solid',
              }}
            >
              접합
            </td>
            <td
              style={{
                color: '#171E26',
                padding: '10px 12px',
                textAlign: 'center',
              }}
            >
              {landUsePlan.landLaw2.touch.map((item: string, index: number) => (
                <div key={index} style={{ textAlign: 'center' }}>
                  {item}
                  {index !== landUsePlan.landLaw2.touch.length - 1 && ','}
                </div>
              ))}
            </td>
          </tr>
        </tbody>
      </table>
    </Container>
  );
};

export default LandUsePlan;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Header = styled.div`
  color: #171e26;
  font-size: 20px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 29px;
  word-wrap: break-word;
  display: flex;
  flex-direction: row;
  gap: 4px;
  justify-content: flex-start;
  align-items: center;

  img {
    width: 20px;
    height: 20px;
  }
`;
